import { Link } from "react-router-dom";
import BrandLogo from "../../assets/images/logo.png";
import { Dropdown } from "react-bootstrap";
import { Auth0ContextInterface, User, useAuth0 } from "@auth0/auth0-react";
import { constants } from "../../config/index";
import enFlag from "../../assets/images/en-flag.png";
import { getConnection } from "../../utils/Functions";
import { userName } from "../../reducers/authSlice";
import { useAppSelector } from "../../app/hooks";

const Header = () => {
  const loggedInUserName = useAppSelector(userName);

  const props = useAuth0();

  const clearSessions = async (props: Auth0ContextInterface<User>) => {
    let federatedLogoutFlag = true;
    let query = "";
    let connectionName = null;
    const clientId = constants.AUTH0_CLIENT_ID;

    let connectionObj = await getConnection(props);

    if (connectionObj && connectionObj.name) {
      connectionName = connectionObj.name;
    } else if (localStorage.getItem("connection")) {
      connectionName = localStorage.getItem("connection");
    }

    if (
      connectionObj &&
      connectionObj.federatedLogout !== "" &&
      connectionObj.federatedLogout !== "null" &&
      connectionObj.federatedLogout !== "undefined"
    ) {
      federatedLogoutFlag = connectionObj.federatedLogout;
    }

    if (
      connectionName &&
      connectionName !== "" &&
      connectionName !== "null" &&
      connectionName !== "undefined"
    ) {
      query = "?connection=" + connectionName;
    }

    props.logout({
      logoutParams: {
        returnTo: window.location.origin + query,
        clientId: clientId,
        connectionName: constants.AUTH0_CONNECTION,
        federated: federatedLogoutFlag,
      },
    });
  };

  return (
    <div className="header-wrapper">
      <div className="brand">
        <Link to="/" aria-label="logo">
          <span className="nbb-icon-Logo-Mark" aria-hidden="true"></span>
        </Link>
      </div>
      <div className="navbar-header">
        <Link to="/">
          <img src={BrandLogo} alt="Nielsen IQ Brandbank" />
        </Link>
      </div>
      <div className="HeaderRightNav">
        <Dropdown>
          <Dropdown.Toggle
            variant="link"
            id="notification-dropdown"
            data-testid="btnNotification"
          >
            <i className="fi fi-rs-bell" />
          </Dropdown.Toggle>

          <Dropdown.Menu align="end">
            <div className="overflow-scroll">
              <Dropdown.Header>
                <span>Notification</span>
              </Dropdown.Header>

              <Dropdown.ItemText>
                <span>No Notification</span>
              </Dropdown.ItemText>
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown>
          <Dropdown.Toggle variant="link" data-testid="btnLanguage">
            <img src={enFlag} className="langLogo" alt="English" /> English
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>
              <img src={enFlag} className="langLogo" alt="English" /> English
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown>
          <Dropdown.Toggle
            variant="link"
            id="user-dropdown"
            data-testid="btnProfile"
          >
            {loggedInUserName}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => clearSessions(props)}
              data-testid="btnSignout"
            >
              Sign out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;
